import { css } from 'styled-components';
import { device } from '../breakpoints';
import { GAP, getArticleWidth, NO_OF_ITEMS } from '../ContentItemCarousel/ContentItemCarousel.styles';
import { StyledPlaceHolderItem, StyledRow2, StyledRow3, StyledRow4 } from './PlaceHolder.styles';

export const getChannelLayout = () => css`
    ${StyledPlaceHolderItem} {
        flex: 0 0 100%;
        display: inline-block;
        margin-right: ${GAP.GTE_XLARGE}px;
        max-width: ${getArticleWidth(GAP.GTE_XLARGE, NO_OF_ITEMS.GTE_XLARGE)};

        ${StyledRow2} {
            display: none;
        }
        ${StyledRow3} {
            display: none;
        }

        ${StyledRow4} {
            display: none;
        }

        @media ${device.GteMedium} {
            ${StyledRow2} {
                display: inline-block;
                padding-bottom: 30px;
                width: 100%;
            }
        }
    }
`;
